"use strict";
(function baseDataProviderDefinition(global) {

  /**
  * Базовый класс провайдера данных.  
  * @since 5.2.0.1100
  * @class WebAccess.components.dataViews.BaseDataProvider
  * @extends BaseObject
  * @property {object} defaults Конфигурация по умолчанию
  */
  global.BaseDataProvider = BaseObject.extend({
    defaults: null,

    init: function (settings) {
      this._super(settings);
      this.defaults = {};
    },

    /**
    * Загружает данные.
    *
    * Метод в чистом виде не используется. Переопределяется наследниками.    
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.BaseDataProvider#load
    * @return {deferred} Deferred-объект
    */
    load: function (loadOptions) {
      var result = $.Deferred();
      var data = [];

      result.resolve(data);
      return result.promise();
    },

    /**
    * Получает количество записей.
    *
    * Метод в чистом виде не используется. Переопределяется наследниками.  
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.BaseDataProvider#totalCount
    * @return {deferred} Deferred-объект
    */
    totalCount: function (filter) {
      var result = $.Deferred();
      var count = 0;

      result.resolve(count);
      return result.promise();
    },

    /**
    * Загружает конфигурацию.
    *
    * Метод в чистом виде не используется. Переопределяется наследниками.     
    * @since 5.2.0.1100
    * @method WebAccess.components.dataViews.BaseDataProvider#loadState
    * @return {deferred} Deferred-объект
    */
    loadState: function () {
      var result = $.Deferred();
      var state = {};

      result.resolve(state);
      return result.promise();
    },

    /**
     * Сохраняет конфигурацию.
     *
     * @method WebAccess.components.dataViews.BaseDataProvider#saveState
     * @return {Deferred<void>}
     * @since 5.2.0.1100
     * @see https://api.jquery.com/category/deferred-object/
     */
    saveState: function () {
      var result = $.Deferred();
      var savedWithoutErrors = true;

      result.resolve(savedWithoutErrors);
      return result.promise();
    },

    /**
    * Расширяет конфигурацию.
    *
    * @method WebAccess.components.dataViews.BaseDataProvider#extendDefaults
    * @since 5.2.0.1100
    * @return {object} Расширенная конфигурация
    */
    extendDefaults: function (loadOptions) {
      var me = this;
      return $.extend({}, this.defaults, loadOptions);
    }
  });

})(WA.CMP.dataViews);